import React from "react";
import { Col } from "antd";

const CustomCol = (props) => <Col {...props}>{props.children}</Col>;
export default CustomCol;
